import React, { Fragment } from 'react'
import { Link } from 'react-router-dom'
import { useAddItem } from '../../Hook/App'
import Layout from '../../Layout'
import Category from '../Category'
import HeaderMain from '../../Components/HeaderMain'
import RenderOption from '../../Components/RenderOption'
import Spinner from '../../Components/Spinner'
function Index() {
    const {
        setForm,
        add,
        preview,
        setPreview,
        onChangeImage,
        clearForm, page,
        setPage,
        form,
        meta,
        selectCategory, category,
        removeImage,
        loadaddItem
    } = useAddItem()

    if (page === 'selectCategory') {
        return <Category callback={selectCategory} back={() => setPage()} />
    }
    return (
        <Layout nav={false}>
            <HeaderMain lable="ثبت اگهی رایگان" leftitem={<div className="p-form" style={{ cursor: "pointer" }} onClick={() => { clearForm(); setPreview(); }}>
                <p>پاکسازی فرم</p>
            </div>} />
            <div className="add-item">
                <div className="main-Add d-flex justify-content-between">

                    <div className="add-picture d-grid position-relative">
                        <input type="file"
                            onChange={onChangeImage}
                            multiple
                            accept="image/png, image/jpeg"
                            style={{ opacity: 0, position: "absolute", width: '100%', height: "100%" }}
                        />
                        <i className="fas fa-plus"></i>
                        <span>افزودن عکس</span>
                    </div>

                    <div className="text-add">
                        {
                            preview &&
                                preview.length ?
                                <div className="d-flex images">
                                    {preview.map((img, i) => {
                                        return (
                                            <div className='image' onClick={() => { removeImage(img.id || img.src) }} key={i}>
                                                <img key={i} src={img.src} width={90} height={90} />
                                                <span className='delete-image'><i className='far fa-times'></i></span>
                                            </div>
                                        );
                                    })}
                                </div>
                                :
                                <Fragment>
                                    <div className="span-color my-2">  <span>انتخاب عکس های اگهی</span></div>
                                    <div className="span-color-2"> <span>اگهی های شامل تصویر بیشتر از5 برابر دیده میشود</span></div>
                                </Fragment>
                        }
                    </div>
                </div>
                <div className="all-input">
                    <span>دسته بندی</span>
                    <input className="input" readOnly value={category && category.title} onClick={() => { setPage('selectCategory') }} />
                    <span>عنوان اگهی</span>
                    <input className="input" value={form.title} onChange={({ target }) => setForm('title', target.value)} />
                    <span>توضیحات</span>
                    <input className="input" value={form.description} onChange={({ target }) => setForm('description', target.value)} />

                    <div className="radioes d-flex justify-content-between pt-4 ml-5">
                        <div className="persona-btn ">
                            <input type="radio" name='type' checked={form.type == 'user'} onClick={() => { setForm('type', 'user') }} />
                            <span>شخصی</span>
                        </div>
                        <div>
                            <input type="radio" name='type' checked={form.type == 'shop'} onClick={() => { setForm('type', 'shop') }} />
                            <span>شرکت/فروشگاه</span>
                        </div>
                    </div>

                    {category && category.all_option && category.all_option.map((option, i) => <RenderOption filter={meta} propClassInput="input" key={i} option={option} onChange={({ target }) => setForm(target.name, target.value)} />)}

                </div>
                <div className="text-rule ">
                    با ثبت اگهی در بوکان شما <Link style={{ color: "#44f" }} to={'/Rule'}>شرایط و قوانین</Link> ان را پذیرفته اید
                </div>
                <div>
                    <button className="btn-notice" disabled={loadaddItem} onClick={add}>{loadaddItem ? <Spinner sm /> : "ثبت اگهی"}</button>
                </div>
            </div>
        </Layout>
    )
}

export default Index